import type { ReactNode } from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { djs } from '@duke-hq/djs';
import { modelDisplayName } from './modelDisplayName';

// Generation details recorded on a ContentTranslation row. Every field is null on rows
// generated before it was recorded, and a re-queued row keeps the values of
// the generation currently being served.
export type TranslationGenerationDetails = {
  generatedAt: Date | string | null;
  model: string | null;
  engineFingerprint: string | null;
};

const DATE_FORMAT = 'D MMM YYYY';

// Null when nothing is recorded, so callers skip the tooltip entirely rather
// than showing an empty bubble.
export function generationDetailsLabel(
  details: TranslationGenerationDetails | undefined,
): ReactNode | null {
  if (details === undefined) {
    return null;
  }
  const { generatedAt, model, engineFingerprint } = details;
  if (generatedAt === null && model === null && engineFingerprint === null) {
    return null;
  }
  return (
    <VStack align="flex-start" spacing={0}>
      {generatedAt !== null ? (
        <Text fontSize="xs">
          <Trans>Generated {djs(generatedAt).format(DATE_FORMAT)}</Trans>
        </Text>
      ) : null}
      {model !== null ? <Text fontSize="xs">{modelDisplayName(model)}</Text> : null}
      {engineFingerprint !== null ? (
        <Text fontSize="xs">
          <Trans>Engine</Trans>{' '}
          <Text as="span" fontFamily="mono">
            {engineFingerprint.slice(0, 7)}
          </Text>
        </Text>
      ) : null}
    </VStack>
  );
}
